import { FC, useState } from 'react';

import { NamePath } from 'antd/es/form/interface';

import { MoneyAmountFormItem } from '@/components/form';

import { CellData } from '../cell-data';

import { getFormattedAmount } from '@/utils';

type TEditableMoneyFormItemProps = {
	name: NamePath;
	itemValue?: string | number;
	required?: boolean;
};

export const EditableMoneyFormItem: FC<TEditableMoneyFormItemProps> = ({
	name,
	itemValue,
	required = false,
}) => {
	const [editMode, setEditMode] = useState<boolean>(true);
	const [shouldAutofocus, setShouldAutofocus] = useState<boolean>(false);

	return editMode ? (
		<MoneyAmountFormItem
			autoFocus={shouldAutofocus}
			controls={false}
			marginBottom={0}
			name={name}
			placeholder=""
			rules={[{ required, message: 'Required' }]}
			suffix={null}
			onBlur={(e) => {
				if (e.target.value === '') {
					e.preventDefault();
					e.stopPropagation();
					return;
				}

				setEditMode(false);
				setShouldAutofocus(true);
			}}
		/>
	) : (
		<CellData style={{ width: '100%' }} onClick={() => setEditMode(true)}>
			{getFormattedAmount(itemValue)}
		</CellData>
	);
};
